var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedCar = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M104.317,493.733c-25.091,0-45.506-20.415-45.506-45.506v-34.449c0-8.14,6.599-14.739,14.739-14.739 h61.534c8.14,0,14.739,6.598,14.739,14.739v34.449C149.825,473.32,129.41,493.733,104.317,493.733z M88.289,428.519v19.71 c0,8.839,7.19,16.028,16.028,16.028s16.028-7.19,16.028-16.028v-19.71H88.289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M407.681,493.733c-25.093,0-45.506-20.415-45.506-45.506v-34.449c0-8.14,6.599-14.739,14.739-14.739 h59.071c0.501,0,0.998-0.027,1.49-0.059c4.066-0.273,8.068,1.158,11.045,3.946s4.668,6.683,4.668,10.761v34.539 C453.187,473.32,432.774,493.733,407.681,493.733z M391.653,428.519v19.71c0,8.839,7.191,16.028,16.028,16.028 c8.837,0,16.028-7.19,16.028-16.028v-19.71H391.653z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B2B0"
    },
    d: "M337.184,177.309L337.184,177.309c27.974,0,50.652,22.678,50.652,50.652v41.162H286.532v-41.162 C286.532,199.988,309.21,177.309,337.184,177.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M387.838,283.863H286.533c-8.14,0-14.739-6.599-14.739-14.739v-41.162 c0-36.057,29.334-65.391,65.391-65.391s65.391,29.334,65.391,65.391v41.162C402.577,277.264,395.978,283.863,387.838,283.863z  M301.272,254.385H373.1v-26.424c0-19.803-16.111-35.914-35.914-35.914s-35.914,16.111-35.914,35.914V254.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B2B0"
    },
    d: "M174.814,177.309L174.814,177.309c27.974,0,50.652,22.678,50.652,50.652v41.162H124.162v-41.162 C124.162,199.988,146.84,177.309,174.814,177.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M225.467,283.863H124.162c-8.14,0-14.739-6.599-14.739-14.739v-41.162 c0-36.057,29.334-65.391,65.391-65.391s65.391,29.334,65.391,65.391v41.162C240.205,277.264,233.607,283.863,225.467,283.863z  M138.9,254.385h71.828v-26.424c0-19.803-16.111-35.914-35.914-35.914S138.9,208.159,138.9,227.962L138.9,254.385L138.9,254.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B2B0"
    },
    d: "M441.522,413.78H70.477c-20.413,0-36.96-16.547-36.96-36.96v-66.936 c0-20.413,16.547-36.96,36.96-36.96h371.046c20.413,0,36.96,16.547,36.96,36.96v66.936 C478.483,397.233,461.936,413.78,441.522,413.78z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M441.522,428.519H70.476c-28.506,0-51.699-23.191-51.699-51.699v-66.936 c0-28.506,23.191-51.699,51.699-51.699h371.047c28.506,0,51.699,23.191,51.699,51.699v66.936 C493.221,405.327,470.03,428.519,441.522,428.519z M70.476,287.662c-12.252,0-22.222,9.968-22.222,22.222v66.936 c0,12.252,9.968,22.222,22.222,22.222h371.047c12.252,0,22.222-9.969,22.222-22.222v-66.936c0-12.252-9.968-22.222-22.222-22.222 L70.476,287.662L70.476,287.662z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M142.239,357.368h-32.922c-8.14,0-14.739-6.599-14.739-14.739s6.599-14.739,14.739-14.739h32.92 c8.14,0,14.739,6.599,14.739,14.739S150.379,357.368,142.239,357.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M402.682,357.368h-32.92c-8.14,0-14.739-6.599-14.739-14.739s6.599-14.739,14.739-14.739h32.92 c8.14,0,14.739,6.599,14.739,14.739S410.822,357.368,402.682,357.368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M67.636,278.754c-0.724,0-1.453-0.053-2.19-0.164c-8.05-1.198-13.605-8.697-12.406-16.749 L79.807,82.158c5.197-36.387,36.912-63.892,73.755-63.892h204.874c36.845,0,68.558,27.505,73.769,63.979 c0.01,0.068,0.019,0.137,0.028,0.205l9.508,73.966h30.375c21.992,0,39.883,17.891,39.883,39.883v16.095 c0,8.14-6.599,14.739-14.739,14.739c-8.14,0-14.739-6.599-14.739-14.739v-16.095c0-5.738-4.668-10.406-10.406-10.406h-43.341 c-7.414,0-13.673-5.506-14.618-12.859L403.01,86.322c-3.189-22-22.335-38.577-44.574-38.577H153.562 c-22.27,0-41.439,16.625-44.587,38.67l-26.78,179.771C81.104,273.499,74.814,278.754,67.636,278.754z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B3404A"
    },
    d: "M14.739,227.132C6.599,227.132,0,220.534,0,212.393v-16.095c0-21.992,17.891-39.883,39.883-39.883 h40.489c8.14,0,14.739,6.599,14.739,14.739s-6.599,14.739-14.739,14.739H39.883c-5.738,0-10.406,4.668-10.406,10.406v16.095 C29.477,220.534,22.879,227.132,14.739,227.132z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedCar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/red-car.16fb2b4c.svg";
export { ForwardRef as ReactComponent };